/**
 * DescriptionOverlay component.
 */
import styled from 'styled-components';

const DescriptionOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2;
`;

export default DescriptionOverlay;
